'use strict';
'use es6';

// Only for properties that won't change

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TermIds$MONTHLY_NO_D;

var _TermIds = require('self-service-api/constants/TermIds');

var TermIds = _interopRequireWildcard(_TermIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_TermIds$MONTHLY_NO_D = {}, _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_NO_DISCOUNT, {
  trackingName: 'Monthly No Discount',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_20_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 20% Discount',
  discountPercent: 0.2,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_25_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 25% Discount',
  discountPercent: 0.25,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_50_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_30_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_NO_DISCOUNT, {
  trackingName: 'Annual No Discount',
  discountPercent: 0,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_20_PERCENT_DISCOUNT, {
  trackingName: 'Annual 20% Discount',
  discountPercent: 0.2,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_25_PERCENT_DISCOUNT, {
  trackingName: 'Annual 25% Discount',
  discountPercent: 0.25,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.HSFS_50_PERCENT_DISCOUNT, {
  trackingName: 'HSFS 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.HSFX_ENTREPRENEUR_DISCOUNT, {
  trackingName: 'HSFE 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.HSFS_90_PERCENT_DISCOUNT, {
  trackingName: 'HSFS 90% Discount',
  discountPercent: 0.9,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_60_PERCENT_DISCOUNT, {
  trackingName: 'Annual 60% Discount',
  discountPercent: 0.6,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_50_PERCENT_DISCOUNT, {
  trackingName: 'Annual 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_30_PERCENT_DISCOUNT, {
  trackingName: 'Annual 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_10_PERCENT_DISCOUNT, {
  trackingName: 'Annual 10% Discount',
  discountPercent: 0.1,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_PLACEHOLDER, {
  trackingName: 'Monthly Placeholder',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_PLACEHOLDER, {
  trackingName: 'ANNUAL Placeholder',
  discountPercent: 0,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_BASIC_TO_PRO_DISCOUNT, {
  trackingName: 'Annual Marketing Basic to Pro Discount',
  discountPercent: 0.25,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_40_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_40_PERCENT_DISCOUNT, {
  trackingName: 'Annual 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'annual'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_PROMO_NO_DISCOUNT, {
  trackingName: 'Monthly Promotional 0% Discount',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), _defineProperty(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_PROMO_NO_DISCOUNT, {
  trackingName: 'Annual Promotional 0% Discount',
  discountPercent: 0,
  commitmentLength: 'annual'
}), _TermIds$MONTHLY_NO_D);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/ImmutableTermIdMap.js
// module id = 241
// module chunks = 3 4 5